import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { MatTooltip } from '@angular/material/tooltip';
import { TranslatePipe } from '@ngx-translate/core';
import { injectFlowState } from '@foblex/flow';
import { FlowActionPanelAction } from '../../enums';
import { FlowConfig, FlowNode, FlowStateConnection } from '../../models';
import { FlowApiService } from '../../services/flow-api.service';

@Component({
  selector: 'iot-platform-ui-flow-action-panel',
  templateUrl: './flow-action-panel.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatTooltip, MatIcon, MatIconButton, FormsModule, MatMenuTrigger, MatMenuItem, MatMenu, TranslatePipe]
})
export class FlowActionPanelComponent {
  public readonly config = input<FlowConfig | null>();
  actions = computed(() => this.config()?.actions ?? []);
  actionMap = computed(() => new Set(this.actions()));
  public readonly processAction = output<FlowActionPanelAction>();
  public readonly resetFlow = output<void>();
  readonly state = injectFlowState<FlowNode, FlowStateConnection, FlowNode>();
  readonly FlowActionPanelAction = FlowActionPanelAction;
  /** Something other than the root node is selected. */
  readonly canRemove = computed(() => {
    const { nodeIds, groupIds, connectionIds } = this.state.selection();
    const selectedNodeIds = [...nodeIds, ...groupIds];
    const rootNodeId = this.state.nodes().find((node) => node.root)?.id;
    return (selectedNodeIds.length > 0 && !selectedNodeIds.includes(rootNodeId as string)) || connectionIds.length > 0;
  });
  private readonly apiService = inject(FlowApiService);

  removeSelected(): void {
    this.apiService.removeSelected();
  }

  reset(): void {
    this.resetFlow.emit();
  }
}
